
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const handleFeaturesClick = () => {
    setMenuOpen(false);
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById('features');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const handlePrivacyClick = () => {
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePricingClick = () => {
    setMenuOpen(false);
    navigate('/pricing');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-[#09090b]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-3 sm:py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 sm:gap-4 group cursor-pointer">
            <img
              src="https://static.readdy.ai/image/151e34d9a5807cd608014213251345d2/83f5e4b8fbdb9e6636dc2fdb7fe48e2c.png"
              alt="HushLegalAI"
              className="h-10 sm:h-14 w-auto transition-transform duration-300 group-hover:scale-105"
            />
            <span className="text-white text-[22px] sm:text-[28px] font-black tracking-tight transition-all duration-300 group-hover:text-[#06b6d4]">
              HushLegalAI
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-10">
            <button
              onClick={handleFeaturesClick}
              className="text-[#a1a1aa] text-[15px] hover:text-[#06b6d4] transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Features
            </button>
            <button
              onClick={handlePrivacyClick}
              className="text-[#a1a1aa] text-[15px] hover:text-[#06b6d4] transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Privacy
            </button>
            <button
              onClick={handlePricingClick}
              className="text-[#a1a1aa] text-[15px] hover:text-[#06b6d4] transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Pricing
            </button>
            <button
              onClick={handleFeaturesClick}
              className="bg-[#d4af37] text-black text-[14px] font-bold px-7 py-3 rounded-full shadow-lg hover:shadow-[0_0_20px_rgba(212,175,55,0.5)] hover:translate-y-[-2px] transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Join Waitlist
            </button>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="lg:hidden flex flex-col items-center justify-center w-10 h-10 gap-[6px] cursor-pointer relative z-[60]"
            aria-label="Toggle menu"
          >
            <span
              className={`block w-6 h-[2px] bg-white rounded-full transition-all duration-300 ${
                menuOpen ? 'rotate-45 translate-y-[8px]' : ''
              }`}
            ></span>
            <span
              className={`block w-6 h-[2px] bg-white rounded-full transition-all duration-300 ${
                menuOpen ? 'opacity-0 scale-0' : ''
              }`}
            ></span>
            <span
              className={`block w-6 h-[2px] bg-white rounded-full transition-all duration-300 ${
                menuOpen ? '-rotate-45 -translate-y-[8px]' : ''
              }`}
            ></span>
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 bg-black/60 backdrop-blur-sm z-[55] transition-opacity duration-300 lg:hidden ${
          menuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setMenuOpen(false)}
      ></div>

      {/* Mobile Menu Panel */}
      <div
        className={`fixed top-0 right-0 h-full w-[280px] bg-[#09090b] border-l border-[#27272a] z-[56] transition-transform duration-300 ease-out lg:hidden ${
          menuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex flex-col pt-24 px-8 gap-2">
          <button
            onClick={handleFeaturesClick}
            className="text-[#a1a1aa] text-[18px] font-medium py-4 text-left hover:text-[#06b6d4] transition-colors duration-200 border-b border-[#1c1c1e] cursor-pointer"
          >
            Features
          </button>
          <button
            onClick={handlePrivacyClick}
            className="text-[#a1a1aa] text-[18px] font-medium py-4 text-left hover:text-[#06b6d4] transition-colors duration-200 border-b border-[#1c1c1e] cursor-pointer"
          >
            Privacy
          </button>
          <button
            onClick={handlePricingClick}
            className="text-[#a1a1aa] text-[18px] font-medium py-4 text-left hover:text-[#06b6d4] transition-colors duration-200 border-b border-[#1c1c1e] cursor-pointer"
          >
            Pricing
          </button>
          <button
            onClick={handleFeaturesClick}
            className="bg-[#d4af37] text-black text-[16px] font-bold px-7 py-4 rounded-full shadow-lg mt-6 whitespace-nowrap cursor-pointer hover:shadow-[0_0_20px_rgba(212,175,55,0.5)] transition-all duration-200"
          >
            Join Waitlist
          </button>
        </div>
      </div>
    </>
  );
}
